module.exports = __webpack_public_path__ + "static/media/login_bottom.240dbd19.png";